const getSubCollectionData = async (workflowRef, subCollection, { orderBy = false, direction }) => {
  if(orderBy) {
    return await workflowRef.collection(subCollection).orderBy(orderBy, direction).get()
  } else {
    return await workflowRef.collection(subCollection).get()
  }
}

module.exports = getSubCollectionData